import React from "react";

function AnimatedDotsBg() {
  return (
    <div className="ambient-background" aria-hidden="true">
      <span className="ambient-orb ambient-orb-one" />
      <span className="ambient-orb ambient-orb-two" />
      <span className="ambient-grid" />
    </div>
  );
}

export default AnimatedDotsBg;
